<template>
    <div :class="['nav_btm', !showBtm ? 'close' : '']">
        <GNB />
    </div>
</template>
<script>
import GNB from "@/views/layout/GNB.vue";
import {mapGetters} from "vuex";
export default {
    name: "Footer",
    components: {
        GNB,
    },
    computed: {
        ...mapGetters({
            showBtm: 'getShowBtm',
        }),
    },
}
</script>
